<template>
  <div>
    <!-- 新增/编辑的对话框 -->
    <el-dialog 
      class="edit-dialog" 
      :title="title" 
      :visible.sync="dialogVisible" 
      width="70%" 
      :modal-append-to-body="true"
      append-to-body 
      close-on-click-modal 
      @closed="handleClose">
      
      <el-form 
        ref="form" 
        :model="form" 
        :rules="rules" 
        label-width="120px" 
        label-position="right">
        
        <!-- 基本信息 -->
        <el-form-item label="策略名称" prop="name" required>
          <el-input 
            v-model="form.name" 
            placeholder="请输入策略名称" 
            maxlength="100" 
            show-word-limit>
          </el-input>
        </el-form-item>
        
        <!-- 弹窗配置 -->
        <el-divider content-position="left">弹窗配置</el-divider>
        
        <div v-for="(config, index) in form.popupConfigs" :key="index" class="popup-config-item">
          <div class="popup-config-header">
            <span class="config-title">弹窗配置 {{ index + 1 }}</span>
            <el-button 
              v-if="index > 0" 
              type="danger" 
              size="small" 
              icon="el-icon-delete" 
              @click="removePopupConfig(index)">
              删除
            </el-button>
          </div>
          
          <el-form-item 
            label="弹窗类型" 
            :prop="`popupConfigs.${index}.popupType`" 
            :required="index === 0">
            <el-select 
              v-model="config.popupType" 
              placeholder="请选择弹窗类型" 
              style="width: 100%;">
              <el-option 
                v-for="option in popupTypeOptions" 
                :key="option.id" 
                :label="option.value" 
                :value="option.id">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item 
            label="弹窗标题" 
            :prop="`popupConfigs.${index}.popupTitle`">
            <el-input 
              v-model="config.popupTitle" 
              placeholder="弹窗标题文案" 
              maxlength="50" 
              show-word-limit>
            </el-input>
          </el-form-item>
          
          <el-form-item 
            label="弹窗描述" 
            :prop="`popupConfigs.${index}.popupContent`">
            <el-input 
              v-model="config.popupContent" 
              placeholder="弹窗描述文案" 
              maxlength="200" 
              show-word-limit>
            </el-input>
          </el-form-item>
        </div>
        
        <el-form-item>
          <el-button 
            type="primary" 
            size="small" 
            icon="el-icon-plus" 
            @click="addPopupConfig">
            添加弹窗配置
          </el-button>
        </el-form-item>
        
        <!-- 命中配置 -->
        <el-divider content-position="left">命中配置</el-divider>
        
        <el-form-item label="渠道配置" prop="channelType" required>
          <el-radio-group v-model="form.channelType" @change="handleChannelTypeChange">
            <el-radio :label="1">全部渠道</el-radio>
            <el-radio :label="2">指定渠道</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item v-if="form.channelType === 2" label="指定渠道" prop="appIds">
          <el-input 
            type="textarea" 
            @focus="channelInputClick" 
            v-model="form.appIds" 
            style="width: 80%;"
            placeholder="点击选择渠道">
          </el-input>
          <channel-popups 
            :isAppendToBody="true" 
            :modelIsAppendToBody="false" 
            :app-id="form.channel.ids"
            :visible.sync="channelVisible" 
            @comfirm="channelConfirm" 
            :multiple="true">
          </channel-popups>
        </el-form-item>
        
        <el-form-item label="应用版本" prop="versionRange" required>
          <el-radio-group v-model="form.versionRange" @change="handleVersionRangeChange">
            <el-radio :label="1">全部版本</el-radio>
            <el-radio :label="2">指定版本范围</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item v-if="form.versionRange === 2" label="版本范围" prop="versionRangeInput">
          <div class="version-range">
            <div class="version-input-container">
              <div class="version-input-group">
                <el-button size="small" @click="decreaseMinVersion">-</el-button>
                <el-input 
                  v-model="form.minClientVersion" 
                  placeholder="0" 
                  style="width: 160px; margin: 0 5px;"
                  @input="handleMinVersionInput"
                 >
                </el-input>
                <el-button size="small" @click="increaseMinVersion">+</el-button>
              </div>
              <div class="version-label">最小版本</div>
            </div>
            <div class="version-input-container">
              <div class="version-input-group">
                <el-button size="small" @click="decreaseMaxVersion">-</el-button>
                <el-input 
                  v-model="form.maxClientVersion" 
                  placeholder="0" 
                  style="width: 160px; margin: 0 5px;"
                  @input="handleMaxVersionInput"
                 >
                </el-input>
                <el-button size="small" @click="increaseMaxVersion">+</el-button>
              </div>
              <div class="version-label">最大版本</div>
            </div>
          </div>
        </el-form-item>
        
        <el-form-item label="UID命中" prop="uidFilterType" required>
          <el-radio-group v-model="form.uidFilterType" @change="handleUidFilterTypeChange">
            <el-radio :label="0">不指定</el-radio>
            <el-radio :label="1">指定</el-radio>
            <el-radio :label="2">排除</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item v-if="form.uidFilterType !== 0" label="UID列表" prop="uidList">
          <el-input
            v-model="form.uidStr"
            placeholder="多个用英文逗号隔开"
            type="textarea"
            style="width: 80%;"
            @blur="handleUidInput">
          </el-input>
        </el-form-item>
        
        <!-- 策略配置 -->
        <el-divider content-position="left">策略配置</el-divider>
        
        <el-form-item label="展示跳转按钮" prop="showJumpButton" required>
          <el-radio-group v-model="form.showJumpButton" @change="handleShowJumpButtonChange">
            <el-radio :label="1">展示</el-radio>
            <el-radio :label="0">不展示</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item v-if="form.showJumpButton === 1" label="关联跳转" prop="showJumpId">
          <el-select v-model="form.showJumpId" placeholder="请选择关联跳转" style="width: 100%">
            <el-option 
              v-for="item in jumpOptions" 
              :key="item.id" 
              :label="`${item.id}-${item.name}`" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="展示预留按钮" prop="showReservedButton" required>
          <el-radio-group v-model="form.showReservedButton" @change="handleShowReservedButtonChange">
            <el-radio :label="1">展示</el-radio>
            <el-radio :label="0">不展示</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item v-if="form.showReservedButton === 1" label="按钮标题" prop="title">
          <el-input 
            v-model="form.title" 
            placeholder="请输入按钮标题">
          </el-input>
        </el-form-item>
        
        <el-form-item v-if="form.showReservedButton === 1" label="事件类型" prop="eventType" required>
          <el-select v-model="form.eventType" placeholder="请选择事件类型" style="width: 100%">
            <el-option label="打开 H5" :value="1"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item v-if="form.showReservedButton === 1" label="事件响应">
          <el-input 
            v-model="form.eventAction" 
            placeholder="请输入H5链接（可选）">
          </el-input>
        </el-form-item>
        
        <el-form-item label="状态" prop="status" required>
          <el-radio-group v-model="form.status">
            <el-radio :label="1">生效</el-radio>
            <el-radio :label="0">失效</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="备注">
          <el-input 
            v-model="form.remark" 
            type="textarea" 
            :rows="3" 
            placeholder="请输入备注（可选）">
          </el-input>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addUpgradePopup, getUpgradePopupDetail, updateUpgradePopup, getAppJumpOptions } from "@/api/apps/upgradePopupManage";
import { getDictionary } from "@/api/system/dictbiz";
import Message from "@/components/Message";
import ChannelPopups from "@/components/channel-popups";

export default {
  name: "UpgradePopupManageEdit",
  components: {
    ChannelPopups,
  },
  data() {
    return {
      /** 对话框是否可见 */
      dialogVisible: false,
      /** 操作类型：add-新增，edit-编辑 */
      operationType: "add",
      /** 编辑的数据ID */
      editId: null,
      /** 提交加载状态 */
      submitLoading: false,
      /** UID输入框的值 */
      uidInput: "",
      /** 渠道输入框的值 */
      channelInput: "",
      /** 跳转选项 */
      jumpOptions: [],
      /** 弹窗类型选项 */
      popupTypeOptions: [],
      /** 渠道选择弹窗是否可见 */
      channelVisible: false,
      /** 表单数据 */
      form: {
        name: "",
        popupConfigs: [
          {
            popupType: null,
            popupTitle: "",
            popupContent: ""
          }
        ],
        channelType: 1,
        channelList: [],
        channel: {
          ids: "",
          names: ""
        },
        appIds: "",
        versionRange: 1,
        minClientVersion: "0",
        maxClientVersion: "0",
        uidFilterType: 0,
        uidList: [],
        uidStr: "",
        showJumpButton: 0,
        showJumpId: "",
        showReservedButton: 0,
        title: "",
        eventType: "",
        eventAction: "",
        status: 1,
        remark: ""
      },
      /** 表单验证规则 */
      rules: {
        name: [
          { required: true, message: "请输入策略名称", trigger: "blur" }
        ],
        channelType: [
          { required: true, message: "请选择渠道类型", trigger: "change" }
        ],
        appIds: [
          { 
            validator: (rule, value, callback) => {
              if (this.form.channelType === 2 && !value) {
                callback(new Error('请选择指定渠道'));
              }
              callback();
            }, 
            trigger: "blur" 
          }
        ],
        versionRange: [
          { required: true, message: "请选择版本范围", trigger: "change" }
        ],
        minClientVersion: [
          { 
            validator: (rule, value, callback) => {
              if (this.form.versionRange === 2) {
                if (!value || !this.form.maxClientVersion) {
                  callback(new Error('请输入版本范围'));
                } else if (parseInt(value) >= parseInt(this.form.maxClientVersion)) {
                  callback(new Error('最小版本必须小于最大版本'));
                }
              }
              callback();
            }, 
            trigger: "blur" 
          }
        ],
        uidStr: [
          { 
            validator: (rule, value, callback) => {
              if (this.form.uidFilterType !== 0 && !this.form.uidStr) {
                callback(new Error('请输入UID列表'));
              }
              callback();
            }, 
            trigger: "blur" 
          }
        ],
        title: [
          { 
            validator: (rule, value, callback) => {
              if (this.form.showReservedButton === 1 && !this.form.title) {
                callback(new Error('请输入按钮标题'));
              }
              callback();
            }, 
            trigger: "blur" 
          }
        ],
        eventType: [
          { 
            validator: (rule, value, callback) => {
              if (this.form.showReservedButton === 1 && !this.form.eventType) {
                callback(new Error('请选择事件类型'));
              }
              callback();
            }, 
            trigger: "change" 
          }
        ]
      }
    };
  },

  computed: {
    /** 弹窗标题 */
    title() {
      return this.operationType === "add" ? "新增升级弹窗策略" : "编辑升级弹窗策略";
    }
  },

  mounted() {
    // 获取跳转选项
    this.getJumpOptions();
    // 获取弹窗类型字典
    this.getPopupTypeOptions();
  },

  methods: {
    /** 获取跳转选项 */
    async getJumpOptions() {
      try {
        const { data } = await getAppJumpOptions();
        this.jumpOptions = data.data || [];
      } catch (error) {
        console.error("获取跳转选项失败", error);
      }
    },

    /** 获取弹窗类型字典 */
    async getPopupTypeOptions() {
      try {
        const { data } = await getDictionary({ code: 'TV_UPGRADE_POPUP' });
        this.popupTypeOptions = data.data.map(item => ({
          id: Number(item.dictKey), // 确保id是数字类型
          value: item.dictValue
        }));
        console.log('弹窗类型选项:', this.popupTypeOptions);
      } catch (error) {
        console.error("获取弹窗类型字典失败", error);
        // 如果接口失败，使用默认选项
        this.popupTypeOptions = [
          { id: 1, value: "下载失败" },
          { id: 2, value: "升级提示" },
          { id: 3, value: "其他" }
        ];
      }
    },

    /** 点击渠道选择框 */
    channelInputClick() {
      this.channelVisible = true;
    },

    /** 确认渠道选择 */
    channelConfirm($event) {
      console.log('渠道选择事件:', $event);
      const { appId, nameStr } = $event;
      this.form.channel.ids = appId;
      this.form.channel.names = nameStr;
      const idAry = appId.split(",");
      const nameAry = nameStr.split(",");
      this.form.appIds = idAry.map((item, index) => {
        return `[${item}] ${nameAry[index]}`;
      }).join('\n');
      
      // 更新channelList数组
      this.form.channelList = idAry.map((id, index) => ({
        channelId: id,
        channelName: nameAry[index] || `渠道${id}`
      }));
      
      console.log('渠道选择后的form数据:', {
        appIds: this.form.appIds,
        channelList: this.form.channelList,
        channel: this.form.channel
      });
      
      // 手动触发验证
      this.$nextTick(() => {
        this.$refs.form.validateField('appIds');
      });
    },

    /** 添加弹窗配置 */
    addPopupConfig() {
      const defaultType = this.popupTypeOptions.length > 0 ? this.popupTypeOptions[0].id : 1;
      this.form.popupConfigs.push({
        popupType: defaultType,
        popupTitle: "",
        popupContent: ""
      });
    },
    
    /** 删除弹窗配置 */
    removePopupConfig(index) {
      if (this.form.popupConfigs.length > 1) {
        this.form.popupConfigs.splice(index, 1);
      }
    },
    
    /** 版本控制方法 */
    decreaseMinVersion() {
      const val = parseInt(this.form.minClientVersion) || 0;
      this.$set(this.form, 'minClientVersion', Math.max(0, val - 1).toString());
    },

    increaseMinVersion() {
      const val = parseInt(this.form.minClientVersion) || 0;
      this.$set(this.form, 'minClientVersion', (val + 1).toString());
    },

    decreaseMaxVersion() {
      const val = parseInt(this.form.maxClientVersion) || 0;
      this.$set(this.form, 'maxClientVersion', Math.max(0, val - 1).toString());
    },

    increaseMaxVersion() {
      const val = parseInt(this.form.maxClientVersion) || 0;
      this.$set(this.form, 'maxClientVersion', (val + 1).toString());
    },

    /** 版本输入处理方法 */
    handleMinVersionInput(value) {
      // 暂时去掉所有限制，允许自由输入
      this.$set(this.form, 'minClientVersion', value);
    },

    handleMaxVersionInput(value) {
      // 暂时去掉所有限制，允许自由输入
      this.$set(this.form, 'maxClientVersion', value);
    },

    handleMinVersionBlur() {
      // 暂时去掉限制，允许自由输入
    },

    handleMaxVersionBlur() {
      // 暂时去掉限制，允许自由输入
    },

    /** UID输入处理方法 */
    handleUidInput() {
      // 在失去焦点时对输入的UID进行去重处理
      const value = this.form.uidStr;
      console.log('UID输入处理 - 原始值:', value);
      
      if (value && value.trim()) {
        const uidArray = value.split(',')
          .map(uid => uid.trim())
          .filter(uid => uid)
          .filter((uid, index, array) => array.indexOf(uid) === index); // 去重
        const processedValue = uidArray.join(',');
        this.$set(this.form, 'uidStr', processedValue);
        console.log('UID输入处理 - 处理后值:', processedValue);
      } else {
        // 显式处理空值情况，确保数据同步
        this.$set(this.form, 'uidStr', '');
        console.log('UID输入处理 - 清空值');
      }
      
      // 手动触发验证，确保表单验证状态同步
      this.$nextTick(() => {
        this.$refs.form.validateField('uidStr');
      });
    },

    /** 显示弹窗 */
    show(type, data = null) {
      this.operationType = type;
      this.dialogVisible = true;
      
      if (type === 'edit' && data && data.id) {
        this.editId = data.id;
        this.getDetail(data.id);
      } else {
        this.resetForm();
      }
    },
    
    /** 获取详情 */
    async getDetail(id) {
      try {
        // 确保字典数据已加载
        if (this.popupTypeOptions.length === 0) {
          await this.getPopupTypeOptions();
        }
        
        const { data } = await getUpgradePopupDetail(id);
        const detailData = data.data;
        
        // 逐个设置属性以保持响应式
        Object.keys(detailData).forEach(key => {
          if (key !== 'popupConfig') {
            this.$set(this.form, key, detailData[key]);
          }
        });
        
        // 处理弹窗配置
        if (detailData.popupConfig) {
          try {
            const popupConfigs = JSON.parse(detailData.popupConfig);
            console.log('解析的弹窗配置:', popupConfigs);
            console.log('当前字典选项:', this.popupTypeOptions);
            
            if (Array.isArray(popupConfigs) && popupConfigs.length > 0) {
              // 确保popupType是数字类型
              const processedConfigs = popupConfigs.map(config => ({
                ...config,
                popupType: Number(config.popupType)
              }));
              console.log('处理后的配置:', processedConfigs);
              this.$set(this.form, 'popupConfigs', processedConfigs);
            } else {
              // 如果没有配置或解析失败，使用默认配置
              this.$set(this.form, 'popupConfigs', [{
                popupType: null,
                popupTitle: "",
                popupContent: ""
              }]);
            }
          } catch (e) {
            console.error('解析popupConfig失败:', e);
            // 解析失败时使用默认配置
            this.$set(this.form, 'popupConfigs', [{
              popupType: null,
              popupTitle: "",
              popupContent: ""
            }]);
          }
        } else {
          // 如果没有popupConfig字段，使用默认配置
          this.$set(this.form, 'popupConfigs', [{
            popupType: null,
            popupTitle: "",
            popupContent: ""
          }]);
        }
        
        // 初始化channel对象
        if (!this.form.channel) {
          this.$set(this.form, 'channel', {
            ids: "",
            names: ""
          });
        }
        
        // 处理渠道列表
        let channelListArray = [];
        if (this.form.channelList) {
          if (Array.isArray(this.form.channelList)) {
            // 已经是数组格式
            channelListArray = this.form.channelList;
          } else if (typeof this.form.channelList === 'string') {
            // 是JSON字符串，需要解析
            try {
              channelListArray = JSON.parse(this.form.channelList);
            } catch (e) {
              console.error('解析channelList失败:', e);
              channelListArray = [];
            }
          }
        }
        
        if (channelListArray.length > 0) {
          // 构建渠道显示文本和ID字符串
          const channelIds = channelListArray.map(item => item.channelId).join(',');
          const channelNames = channelListArray.map(item => item.channelName).join(',');
          const channelDisplayText = channelListArray.map(item => `[${item.channelId}] ${item.channelName}`).join('\n');
          
          this.$set(this.form.channel, 'ids', channelIds);
          this.$set(this.form.channel, 'names', channelNames);
          this.$set(this.form, 'appIds', channelDisplayText);
          this.$set(this.form, 'channelList', channelListArray);
        } else {
          this.$set(this.form, 'channelList', []);
          this.$set(this.form, 'appIds', "");
        }
        
        // 处理版本范围信息
        if (this.form.versionRangeInfo && this.form.versionRange === 2) {
          // 解析版本范围信息，格式如 "[30, 80]"
          const versionMatch = this.form.versionRangeInfo.match(/\[(\d+),\s*(\d+)\]/);
          if (versionMatch) {
            this.$set(this.form, 'minClientVersion', versionMatch[1]);
            this.$set(this.form, 'maxClientVersion', versionMatch[2]);
          }
        }
        
        // 处理UID列表
        let uidListArray = [];
        if (this.form.uidList) {
          if (Array.isArray(this.form.uidList)) {
            // 已经是数组格式
            uidListArray = this.form.uidList;
          } else if (typeof this.form.uidList === 'string') {
            // 是JSON字符串，需要解析
            try {
              uidListArray = JSON.parse(this.form.uidList);
            } catch (e) {
              console.error('解析uidList失败:', e);
              uidListArray = [];
            }
          }
        }
        
        if (uidListArray.length > 0) {
          this.$set(this.form, 'uidStr', uidListArray.join(','));
          this.$set(this.form, 'uidList', uidListArray);
        } else {
          this.$set(this.form, 'uidList', []);
          this.$set(this.form, 'uidStr', "");
        }
        
        // 处理弹窗类型，如果为-1则设为默认值
        if (this.form.popupType === -1) {
          this.$set(this.form, 'popupType', 1);
        }
        
        // 确保数组格式
        if (!Array.isArray(this.form.channelList)) {
          this.$set(this.form, 'channelList', []);
        }
        if (!Array.isArray(this.form.uidList)) {
          this.$set(this.form, 'uidList', []);
        }
      } catch (error) {
        console.error("获取详情失败", error);
        Message.error("获取详情失败");
      }
    },
    
    /** 重置表单 */
    resetForm() {
      this.form = {
        name: "",
        popupConfigs: [
          {
            popupType: null,
            popupTitle: "",
            popupContent: ""
          }
        ],
        channelType: 1,
        channelList: [],
        channel: {
          ids: "",
          names: ""
        },
        appIds: "",
        versionRange: 1,
        minClientVersion: "0",
        maxClientVersion: "0",
        uidFilterType: 0,
        uidList: [],
        uidStr: "",
        showJumpButton: 0,
        showJumpId: "",
        showReservedButton: 0,
        title: "",
        eventType: "",
        eventAction: "",
        status: 1,
        remark: ""
      };
      this.uidInput = "";
      this.channelInput = "";
      this.editId = null;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    
    /** 渠道类型变化 */
    handleChannelTypeChange() {
      // 不清空数据，保持用户已选择的数据
    },
    
    /** 版本范围变化 */
    handleVersionRangeChange() {
      // 不清空数据，保持用户已输入的数据
    },
    
    /** UID过滤类型变化 */
    handleUidFilterTypeChange() {
      // 不清空数据，保持用户已输入的数据
    },
    
    /** 跳转按钮变化 */
    handleShowJumpButtonChange() {
      // 不清空数据，保持用户已选择的数据
    },
    
    /** 预留按钮变化 */
    handleShowReservedButtonChange() {
      // 不清空数据，保持用户已输入的数据
    },
    
    /** 添加渠道 */
    addChannel() {
      if (!this.channelInput.trim()) return;
      const channels = this.channelInput.split(',').map(id => id.trim()).filter(id => id);
      channels.forEach(id => {
        if (!this.form.channelList.find(channel => channel.channelId === id)) {
          this.form.channelList.push({
            channelId: id,
            channelName: `渠道${id}`
          });
        }
      });
      this.channelInput = "";
    },
    
    /** 删除渠道 */
    removeChannel(index) {
      this.form.channelList.splice(index, 1);
    },
    
    /** 添加UID */
    addUid() {
      if (!this.uidInput.trim()) return;
      const uids = this.uidInput.split(',').map(uid => uid.trim()).filter(uid => uid);
      uids.forEach(uid => {
        if (!this.form.uidList.includes(uid) && this.form.uidList.length < 100) {
          this.form.uidList.push(uid);
        }
      });
      this.uidInput = "";
    },
    
    /** 删除UID */
    removeUid(index) {
      this.form.uidList.splice(index, 1);
    },
    
    /** 提交表单 */
    submitForm() {
      console.log('开始提交表单，当前表单数据:', this.form);
      this.$refs.form.validate(async (valid) => {
        console.log('表单验证结果:', valid);
        if (!valid) {
          console.log('表单验证失败，停止提交');
          return;
        }
        
        this.submitLoading = true;
        try {
          // 检查popupType是否重复
          const popupTypes = this.form.popupConfigs.map(config => config.popupType);
          const uniqueTypes = [...new Set(popupTypes)];
          if (popupTypes.length !== uniqueTypes.length) {
            Message.error('弹窗类型不能重复，请检查配置');
            this.submitLoading = false;
            return;
          }
          
          const submitData = { ...this.form };
          
          // 处理弹窗配置，转换为JSON格式
          submitData.popupConfig = JSON.stringify(this.form.popupConfigs);
          
          // 移除不需要的字段
          delete submitData.popupConfigs;
          
          // 处理渠道列表
          if (this.form.channelType === 1) {
            // 全部渠道，设置为空数组
            submitData.channelList = [];
          } else {
            // 指定渠道，使用form.channelList数组（保持为JSON对象）
            if (Array.isArray(this.form.channelList)) {
              submitData.channelList = this.form.channelList;
            } else {
              submitData.channelList = [];
            }
          }
          
          // 处理UID列表
          if (this.form.uidFilterType === 0) {
            // 不指定UID，设置为空数组
            submitData.uidList = [];
          } else {
            // 指定或排除UID，从uidStr转换（保持为JSON对象）
            if (this.form.uidStr && this.form.uidStr.trim()) {
              const uidArray = this.form.uidStr.split(',')
                .map(uid => uid.trim())
                .filter(uid => uid)
                .filter((uid, index, array) => array.indexOf(uid) === index); // 去重
              submitData.uidList = uidArray;
            } else {
              submitData.uidList = [];
            }
          }
          
          // 移除不需要提交的字段
          delete submitData.channel;
          delete submitData.appIds;
          delete submitData.uidStr;
          
          // 调试日志
          console.log('提交数据:', {
            channelType: submitData.channelType,
            channelList: submitData.channelList,
            uidFilterType: submitData.uidFilterType,
            uidList: submitData.uidList
          });
          
          console.log('准备提交的数据:', submitData);
          console.log('操作类型:', this.operationType);
          
          if (this.operationType === 'add') {
            console.log('开始调用新增API');
            const result = await addUpgradePopup(submitData);
            console.log('新增API响应:', result);
            Message.success("新增成功");
          } else if (this.operationType === 'edit') {
            submitData.id = this.editId;
            console.log('开始调用编辑API');
            const result = await updateUpgradePopup(submitData);
            console.log('编辑API响应:', result);
            Message.success("编辑成功");
          }
          
          this.dialogVisible = false;
          this.$emit("reload");
        } catch (error) {
          console.error('提交失败，错误详情:', error);
          console.error('错误响应:', error.response);
          // 不显示错误消息，因为axios拦截器已经处理了
        } finally {
          this.submitLoading = false;
        }
      });
    },
    
    /** 关闭弹窗 */
    handleClose() {
      this.resetForm();
    }
  }
};
</script>

<style lang="scss" scoped>
.channel-input-container,
.uid-input-container {
  margin-bottom: 10px;
}

.channel-list,
.uid-list {
  margin-top: 10px;
}

.uid-count {
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}

.version-range {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.version-input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.version-input-group {
  display: flex;
  align-items: center;
}

.version-label {
  margin-top: 5px;
  font-size: 12px;
  color: #606266;
  text-align: center;
  width: 100%;
}

/* 隐藏版本输入框的上下箭头 */
.version-input-group .el-input__inner {
  appearance: textfield;
  -moz-appearance: textfield;
}

.version-input-group .el-input__inner::-webkit-outer-spin-button,
.version-input-group .el-input__inner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.dialog-footer {
  text-align: right;
}

.popup-config-item {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  background-color: #fafafa;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.popup-config-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
}

.config-title {
  font-weight: 600;
  color: #303133;
  font-size: 14px;
}
</style> 